import createReducer from 'reducers/createReducer';

import { PaymentInfo } from 'actions/actionTypes';

const INITIAL_STATE = { 
    billReceive: {
        isReceiveBillSms: false,
        isReceiveBillEmail: false
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [PaymentInfo.CHANGE_SHOP_BILL_RECEIVE_INFO]: (state, action) => {
        state.billReceive[action.payload.name] = action.payload.value;
    },

    [PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_SUCCESS]: (state, action) => {
        state.billReceive.isReceiveBillSms = action.payload.isReceiveBillSms;
        state.billReceive.isReceiveBillEmail = action.payload.isReceiveBillEmail;
    },
    [PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    }
});


export default reducer;